import {UrmCommand} from "./UrmCommand.js";
import {InvalidArgumentException, IndexOutOfBoundsException} from "../../errors/Exceptions.js";


/**
 * Simple wrapper for array of commands
 */
export class UrmProgram {
    #commands; // array of UrmCommand objects; does not contain empty elements; length >=1

    /**
     *
     * @param commands {UrmCommand[]} is non-empty non-sparse array of commands -- <code>UrmCommand</code> objects
     */
    constructor(commands) {
        if(!Array.isArray(commands)){
            throw new InvalidArgumentException("commands must be an Array");
        }
        if(commands.length <= 0){
            throw new InvalidArgumentException("commands array can't be empty");
        }

        for(let i = 0; i < commands.length; i++){
            if (!(commands[i] instanceof UrmCommand)) {
                throw new InvalidArgumentException("Each element of commands array must be a valid UrmCommand object");
            }
        }

        this.#commands = commands;
    }


    /**
     * Returns number of commands in program
     * @return {number}
     */
    get commandsCount(){
        return this.#commands.length;
    }

    /**
     * Returns index of last command. Recall, **index starts from 1**.
     * Result of this property is equal to <code>commandsCount</code> property.
     * @return {number} index of last command in program
     */
    get lastCommandIndex(){
        return this.#commands.length;
    }

    /**
     * Gives command by index
     * @param index {number} must be >= 1
     * @return {UrmCommand}
     */
    getCommandByIndex(index) {
        if(index < 1){
            throw new InvalidArgumentException("Index must be > 0");
        }
        if(index > this.#commands.length){
            throw new IndexOutOfBoundsException("Index is out of bounds");
        }

        return this.#commands[index - 1];
    }

    /**
     * Gives maximum register index, that is mentioned in program.
     * Function may be useful when URM allocates array for its registers according to received UrmProgram
     * @return {number}
     */
    getMaximumMentionedRegisterIndex(){
        let maxRegister;
        this.#commands.forEach((command, i, arr) => {
            if(maxRegister === undefined ||
                maxRegister < command.getMaximumMentionedRegisterIndex()){
                maxRegister = command.getMaximumMentionedRegisterIndex();
            }
        });
        return maxRegister;
    }

    /**
     *
     * @return {string} pretty string representation of Program (one command per line)
     */
    toString(){
        let str = "";
        let maxCommandIndexLength = this.lastCommandIndex.toString().length; // for pretty formatting

        this.#commands.forEach((command, i) => {
            let idx = i + 1;
            str += ' '.repeat(maxCommandIndexLength - idx.toString().length) + `${idx}) ` + command.toString() + '\n';
        });
        str = str.slice(0, -1); // delete last \n

        return str;
    }


}